import { render, staticRenderFns } from "./popup-stat.vue?vue&type=template&id=11860056&scoped=true&"
import script from "./popup-stat.vue?vue&type=script&lang=js&"
export * from "./popup-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11860056",
  null
  
)

export default component.exports